import styles from './EscolhaIcone.module.css'
import { motion } from 'framer-motion'
import { useState } from 'react'
import { useFormacao } from 'Common/Context/Formacao'

export default function EscolhaIcone() {
    const { icones, iconeClicado, listaFormacoes } = useFormacao()
    return (
        <ul className={styles.lista}>
            {listaFormacoes.map(item => {
                return (
                    item.ativo
                        ?
                        <motion.li className={styles.ativo} key={item.icone} onClick={() => iconeClicado(item)}>{icones[item.icone]}</motion.li>
                        :
                        <motion.li className={styles.icone} key={item.icone} onClick={() => iconeClicado(item)}>{icones[item.icone]}</motion.li>)
            })}
        </ul>
    )
}
